import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Play, Trash2, ChevronDown } from 'lucide-react';
import { InstrumentPicker } from './InstrumentPicker';

export const TrackListItem = ({ 
  track, 
  index, 
  isSelected, 
  onSelect, 
  onMute, 
  onSolo, 
  onRecordArm, 
  onDelete, 
  onChangeInstrument, 
  onTestSound, 
  userSamples, 
  instrumentPackages, 
  loadingInstrument, 
  isAuthenticated, 
  authLoading 
}) => {
  const [showPicker, setShowPicker] = useState(false);
  
  return (
    <div className={`border-b border-[#252525] ${isSelected ? 'bg-blue-900/30' : 'hover:bg-white/5'}`} data-testid={`track-${index}`}>
      <div className="flex items-center px-2 py-2 cursor-pointer" onClick={onSelect}>
        <div className="w-1.5 h-10 rounded-full mr-2" style={{ backgroundColor: track.color }} />
        <span className="text-gray-500 text-xs w-5">{index + 1}</span>
        
        <div className="flex-1 min-w-0 ml-1">
          <div className="text-sm font-medium truncate">{track.name}</div>
          <div className="flex items-center gap-2">
            <button onClick={(e) => { e.stopPropagation(); setShowPicker(!showPicker); }} className="text-xs text-gray-500 hover:text-white flex items-center gap-1" data-testid={`track-inst-${index}`}>
              {track.instrumentName} <ChevronDown className="w-3 h-3" />
            </button>
            {track.isPackage && (
              <span className="text-[9px] bg-purple-500/20 text-purple-400 px-1 rounded">KIT</span>
            )}
            {track.isUserSample && track.syncToProjectTempo && (
              <span className="text-[9px] bg-green-500/20 text-green-400 px-1 rounded" title={`Sample: ${track.sampleBpm} BPM`}>
                {track.sampleBpm}->SYNC
              </span>
            )}
          </div>
        </div>
        
        <div className="flex items-center gap-0.5">
          {/* Test Sound button for user samples and kits */}
          {(track.isUserSample || track.isPackage) && (
            <button 
              onClick={(e) => { 
                e.stopPropagation(); 
                onTestSound();
              }} 
              className="w-5 h-5 rounded text-[9px] font-bold flex items-center justify-center bg-green-600 hover:bg-green-500 text-white" 
              title="Test Sound"
            >
              <Play className="w-3 h-3" />
            </button>
          )}
          <button onClick={(e) => { e.stopPropagation(); onRecordArm(); }} className={`w-5 h-5 rounded text-[9px] font-bold flex items-center justify-center ${track.recordArmed ? 'bg-red-500 text-white' : 'bg-[#333] text-gray-500'}`} title="Record Arm">
            R
          </button>
          <button onClick={(e) => { e.stopPropagation(); onMute(); }} className={`w-5 h-5 rounded text-[9px] font-bold flex items-center justify-center ${track.muted ? 'bg-red-600 text-white' : 'bg-[#333] text-gray-500'}`} title="Mute">
            M
          </button>
          <button onClick={(e) => { e.stopPropagation(); onSolo(); }} className={`w-5 h-5 rounded text-[9px] font-bold flex items-center justify-center ${track.solo ? 'bg-yellow-500 text-black' : 'bg-[#333] text-gray-500'}`} title="Solo">
            S
          </button>
          <button onClick={(e) => { e.stopPropagation(); onDelete(); }} className="w-5 h-5 rounded flex items-center justify-center text-gray-500 hover:text-red-400 hover:bg-red-500/20" title="Delete">
            <Trash2 className="w-3 h-3" />
          </button>
        </div>
      </div>
      
      <AnimatePresence>
        {showPicker && (
          <motion.div initial={{ height: 0 }} animate={{ height: 'auto' }} exit={{ height: 0 }} className="overflow-hidden bg-[#0a0a0a]">
            <InstrumentPicker track={track} onSelect={(id) => { onChangeInstrument(id); setShowPicker(false); }} userSamples={userSamples} instrumentPackages={instrumentPackages} loadingInstrument={loadingInstrument} isAuthenticated={isAuthenticated} authLoading={authLoading} />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default TrackListItem;
